import React from 'react';
import { motion } from 'framer-motion';
import { RocketLaunchIcon, CheckCircleIcon } from '@heroicons/react/24/outline';

const steps = ['Understand', 'Define', 'Sketch', 'Decide', 'Prototype'];

const DesignSprintDemo: React.FC = () => {
  const yPositions = [0, 44, 88, 132, 176, 0];

  return (
    <div className="bg-gradient-to-br from-purple-500 to-indigo-600 rounded-2xl p-8 shadow-2xl">
      <div className="bg-white/10 rounded-lg p-6 backdrop-blur-sm relative overflow-hidden">
        <div className="flex items-center justify-between mb-4 text-white">
          <div className="flex items-center gap-2">
            <div className="w-8 h-8 bg-white/20 rounded-full flex items-center justify-center">
              <RocketLaunchIcon className="w-4 h-4 text-white" />
            </div>
            <span className="font-medium">Design Sprint</span>
          </div>
          <div className="text-sm">Day 3 of 5</div>
        </div>

        <div className="relative">
          {/* Animated highlight behind current step */}
          <motion.div
            className="absolute left-0 right-0 h-10 rounded-lg bg-white/15"
            style={{ top: 0 }}
            animate={{ y: yPositions }}
            transition={{ duration: 6, repeat: Infinity, ease: 'easeInOut' }}
          />

          <ul className="relative space-y-2">
            {steps.map((label, idx) => (
              <li key={label} className="relative z-10 flex items-center justify-between p-3 rounded-lg">
                <span className="text-white text-sm">{label}</span>
                {idx < 2 ? (
                  <CheckCircleIcon className="w-4 h-4 text-emerald-300" />
                ) : (
                  <div className="w-4 h-4 bg-white/30 rounded-full" />
                )}
              </li>
            ))}
          </ul>

          {/* Progress dot along the left side */}
          <motion.div
            className="absolute left-[-10px] top-[8px] w-3 h-3 rounded-full bg-white shadow"
            animate={{ y: yPositions.map((v) => v + 2) }}
            transition={{ duration: 6, repeat: Infinity, ease: 'easeInOut' }}
          />
        </div>
      </div>
    </div>
  );
};

export default DesignSprintDemo;


